var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders, buildAuditLogSearchParams } from "./apiUtils";
var AUDIT_LOGS_ENDPOINT = "czna-users/audit-logs";
var DEFAULT_LIMIT = 50;
export var fetchAuditLogs = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, page, _b, limit, _c, sort, searchParams;
    return __generator(this, function (_d) {
        _a = params.page, page = _a === void 0 ? 1 : _a, _b = params.limit, limit = _b === void 0 ? DEFAULT_LIMIT : _b, _c = params.sort, sort = _c === void 0 ? "-created_at" : _c;
        searchParams = buildAuditLogSearchParams(params);
        searchParams.set("page", page.toString());
        searchParams.set("limit", limit.toString());
        searchParams.set("sort", sort);
        return [2 /*return*/, ky
                .get("".concat(AUDIT_LOGS_ENDPOINT, "?").concat(searchParams), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchAuditLogExport = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response, blob, url, a;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = buildAuditLogSearchParams(params);
                return [4 /*yield*/, ky.get("".concat(AUDIT_LOGS_ENDPOINT, "/export?").concat(searchParams), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                url = window.URL.createObjectURL(blob);
                a = document.createElement("a");
                a.href = url;
                a.download = "audit-log-export.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                return [2 /*return*/];
        }
    });
}); };
export var fetchAuditLogDetail = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get("".concat(AUDIT_LOGS_ENDPOINT, "/").concat(id), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
